var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { Autocomplete, Box, Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, Menu, MenuItem, OutlinedInput, Paper, Select, TextField, Tooltip, Typography, } from "@mui/material";
import { DataGrid, GridMoreVertIcon, } from "@mui/x-data-grid";
import { Plus } from "@phosphor-icons/react";
import { useContext, useEffect, useState, useMemo, useCallback, } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Modules } from "../../../application/common/enums/screen-name";
import { objectStatusBgColor, objectStatusMapping, objectStatusTextColor, resultTextColor, statusTextColor, getObjectStatusColors, } from "../../../application/common/utils/column-helper";
import { checkCreateEdit, checkRead } from "../../../application/common/utils/roles-helper";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import LeadsObjectApi from "../../../infrastructure/api/pages/lead-object-api";
import ObjectStatusApi from "../../../infrastructure/api/pages/object-status-api";
import AssignObjectToLeadModal from "./AssignObjectToLeadModal";
import ObjectModal from "./ObjectModal";
import { convertToNLEuroFormat } from "../../../application/common/utils/helper";
import ChangeStatusModal from "./ChangeStatusModal";
const initialFormData = {
    id: null,
    leadObjectId: null,
    leadId: "",
    companyRoleId: "",
    street: "",
    name: "",
    houseNumber: "",
    addition: "",
    postalCode: "",
    city: "",
    totalRoofSurfaces: 0,
    price: 0,
    area: 0,
    roofAccess: null,
    context: null,
    registrationTime: 0,
    preferredMonth: undefined,
    image: undefined,
    isDeleted: false,
    openingEndHoursString: "17:00",
    openingStartHoursString: "09:00",
    locationId: "",
    location: null,
    longitude: "",
    latitude: "",
    pandId: "",
    installationDate: undefined,
    isSpecial: false,
    projectNumber: "",
    externalComments: "",
    internalComments: "",
    objectID: 0,
    drawingLink: "",
    originIds: [],
    origins: [],
};
//
const ObjectTab = ({ setRefreshModalData, refreshObjects, setActionTabRefresh, leadObjectsProp = [], isObjectLoading = false, tabIndex, objectTabIndex = 2, // default to 2, as in LeadDetailsTabs
 }) => {
    // Replace anchorEl state with menuAnchor and menuRowId
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [menuRowId, setMenuRowId] = useState(null);
    const handleOpenMenu = (event, rowId) => {
        setMenuAnchor(event.currentTarget);
        setMenuRowId(rowId);
    };
    const handleCloseMenu = () => {
        setMenuAnchor(null);
        setMenuRowId(null);
    };
    const [leadObject, setLeadobject] = useState(initialFormData);
    const [refresh, setRefresh] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [changeStatusOpen, setChangeStatusModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const { t: translate } = useTranslation();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    const [companyRoles, setCompanyRoles] = useState([]);
    const [modalAssignObjectOpen, setModalAssignObjectOpen] = useState(false);
    const [selectedObjectId, setSelectedObjectId] = useState("");
    const [leadOptions, setLeadOptions] = useState([]);
    const [assetOptions, setAssetOptions] = useState([]);
    const [leadObjects, setLeadObjects] = useState([]);
    const [statusTree, setStatusTree] = useState([]);
    // Extract leadId from URL params
    const leadId = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("id") || "";
    }, []);
    // Include an explicit "All" option for the Company Role filter dropdown
    const companyRoleFilterOptions = useMemo(() => [
        { id: "__all__", name: translate("All") },
        ...(Array.isArray(companyRoles) ? companyRoles : []),
    ], [companyRoles, translate]);
    // Generate a stable, unique row identifier for the grid and menus
    const resolveRowId = useCallback((row) => {
        var _a;
        if (row.leadObjectId && row.leadObjectId !== "")
            return String(row.leadObjectId);
        if (row.id && row.id !== "")
            return String(row.id);
        const objectIdPart = row.objectID != null ? String(row.objectID) : "no-object-id";
        const rolePart = (_a = row.companyRoleId) !== null && _a !== void 0 ? _a : "no-role";
        return `${objectIdPart}-${rolePart}`;
    }, []);
    const handleOpenModal = useCallback(() => {
        setModalOpen(true);
    }, []);
    const handleOpenChangeStatusModal = useCallback(() => {
        setChangeStatusModalOpen(true);
    }, []);
    const handleCloseChangeStatusModal = useCallback(() => {
        setChangeStatusModalOpen(false);
    }, []);
    const handleCloseModal = () => {
        setModalOpen(false);
        // Reset leadObject after modal animation completes
        setTimeout(() => {
            setLeadobject(initialFormData);
        }, 300);
    };
    const handleCloseAssignObjectModal = () => {
        setModalAssignObjectOpen(false);
    };
    const handleOpenAssignObjectModal = (leadObjectId) => {
        setSelectedObjectId(leadObjectId);
        setModalAssignObjectOpen(true);
        handleCloseMenu();
    };
    const deleteObject = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield LeadsObjectApi.deleteLeadObject(id).then((response) => {
            if (response.status === 200) {
                toast.success(translate("DeletedSuccessfully"));
                setRefresh((prev) => !prev);
                setRefreshModalData((prev) => !prev);
                setActionTabRefresh((prev) => !prev);
            }
        });
    });
    const getCompanyRoles = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield LeadsObjectApi.getCompanyRoles();
        if (result.data) {
            setCompanyRoles(result.data);
        }
    }), []);
    useEffect(() => {
        getCompanyRoles();
    }, [getCompanyRoles]);
    // Keep local leadObjects in sync with incoming props initially/when parent updates
    useEffect(() => {
        if (leadObjectsProp && leadObjectsProp.length >= 0) {
            setLeadObjects(leadObjectsProp);
        }
    }, [leadObjectsProp]);
    // Load status tree once for passing to modals
    useEffect(() => {
        ObjectStatusApi.getTree().then((res) => {
            const tree = res.data || [];
            setStatusTree(tree);
        });
    }, []);
    useEffect(() => {
        if (selectedObjectId) {
            LeadsObjectApi.getAllLeadsExceptGivenObjectId(selectedObjectId)
                .then((response) => {
                if (response.status === 200 && response.data != null) {
                    setLeadOptions(response.data);
                }
            })
                .finally(() => { });
        }
    }, [selectedObjectId]);
    useEffect(() => {
        LeadsObjectApi.getSelectionListSystems()
            .then((response) => {
            if (response.status === 200 && response.data != null) {
                setAssetOptions(response.data);
            }
        })
            .finally(() => { });
    }, [refresh]);
    useEffect(() => {
        if (assetOptions.length > 0) {
            setLoading(true);
            const mapped = (leadObjectsProp || []).map((leadobject) => {
                const selectionListSystems = leadobject.selectionListSystemsId &&
                    leadobject.selectionListSystemsId.map((id) => {
                        var _a;
                        return ({
                            value: id,
                            text: (_a = assetOptions.find((option) => option.value === id)) === null || _a === void 0 ? void 0 : _a.text,
                        });
                    });
                return Object.assign(Object.assign({}, leadobject), { selectionListSystems });
            });
            setLeadObjects(mapped);
            setRefreshModalData((prev) => !prev);
            setLoading(false);
        }
    }, [
        refresh,
        refreshObjects,
        assetOptions,
        leadObjectsProp,
        setRefreshModalData,
    ]);
    useEffect(() => {
        if (leadObject.leadObjectId) {
            setLeadobject(leadObject);
            handleOpenModal();
        }
    }, [leadObject, handleOpenModal]);
    const handleOpenEditModal = (row) => {
        setLeadobject(row);
        setModalOpen(true);
        handleCloseMenu();
    };
    const handleEvent = (params) => {
        handleOpenEditModal(params.row);
    };
    const columnsForDataGrid = [
        {
            field: "objectID",
            headerName: translate("ID"),
            sortable: true,
            align: "left",
            disableColumnMenu: true,
            headerAlign: "left",
            hideable: false,
            filterable: true,
            minWidth: 100,
        },
        {
            field: "name",
            headerName: translate("Name"),
            sortable: true,
            align: "left",
            headerAlign: "left",
            disableColumnMenu: true,
            hideable: false,
            filterable: true,
            minWidth: 150,
        },
        {
            field: "address",
            headerName: translate("Adres/GPS"),
            sortable: true,
            align: "left",
            headerAlign: "left",
            disableColumnMenu: true,
            hideable: false,
            filterable: true,
            minWidth: 200,
            renderCell: (params) => {
                const { street, houseNumber, addition, postalCode, city, longitude, latitude, objectFullAddress, } = params.row;
                // Prefer the stored full address; otherwise compose in Dutch format.
                let address = (objectFullAddress === null || objectFullAddress === void 0 ? void 0 : objectFullAddress.trim()) ? objectFullAddress.trim() : "";
                if (!address && (street || houseNumber || addition || postalCode || city)) {
                    address = [
                        [street, houseNumber, addition].filter(Boolean).join(" "),
                        [postalCode, city].filter(Boolean).join(" "),
                    ]
                        .filter(Boolean)
                        .join(", ");
                }
                if (address.trim()) {
                    return _jsx("span", { children: address });
                }
                else if (longitude && latitude) {
                    return (_jsxs("span", { children: [longitude, ", ", latitude] }));
                }
                else {
                    return _jsx("span", { children: "No address" });
                }
            },
        },
        {
            field: "companyRoleName",
            headerName: translate("Role"),
            sortable: true,
            align: "left",
            headerAlign: "left",
            hideable: false,
            disableColumnMenu: true,
            filterable: true,
            minWidth: 150,
        },
        {
            field: "status",
            headerName: translate("Status"),
            sortable: false,
            align: "left",
            headerAlign: "left",
            hideable: false,
            filterable: true,
            hideSortIcons: true,
            minWidth: 150,
            flex: 1,
            disableColumnMenu: true,
            renderCell: (params) => {
                const row = params.row;
                // Always show Level 1 status name (primary status category)
                const dynamicLabel = row.statusLevel1Name;
                const fallbackLabel = translate(`${objectStatusMapping[params.row.status]}`);
                const label = dynamicLabel || fallbackLabel;
                // Get colors based on the status name (new dynamic system) or fall back to old enum-based colors
                const colors = dynamicLabel
                    ? getObjectStatusColors(dynamicLabel)
                    : {
                        bgColor: objectStatusBgColor[params.row.status] || "#E9ECEF",
                        textColor: objectStatusTextColor[params.row.status] || "#495057",
                    };
                return (_jsx(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "100%"
                    }, children: _jsx(Box, { sx: {
                            bgcolor: colors.bgColor,
                            padding: 1,
                            mt: 1,
                            borderRadius: 2,
                            maxWidth: "calc(100% - 10px)",
                            cursor: "pointer"
                        }, children: _jsx(Tooltip, { title: label, arrow: true, children: _jsx(Typography, { variant: "h5", sx: {
                                    width: "100%",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "block",
                                    color: colors.textColor,
                                }, children: label }) }) }) }));
            },
        },
        {
            field: "internalComments",
            headerName: translate("InternalComments"),
            sortable: false,
            align: "left",
            headerAlign: "left",
            hideable: false,
            disableColumnMenu: true,
            filterable: true,
            hideSortIcons: true,
            minWidth: 150,
            renderCell: (params) => (_jsxs(Box, { sx: {
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    height: "100%",
                }, children: [_jsx(Typography, { sx: {
                            whiteSpace: "pre-wrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxHeight: "60px",
                            lineHeight: "1.2",
                        }, children: params.value }), params.value && (_jsx(Tooltip, { title: _jsx(Typography, { sx: { whiteSpace: "pre-wrap" }, children: params.value }), children: _jsx(InfoOutlined, { sx: { width: "13px", height: "13px", color: "#009DDC" } }) }))] })),
        },
        {
            field: "price",
            headerName: translate("Price"),
            sortable: false,
            align: "left",
            headerAlign: "left",
            hideable: false,
            filterable: true,
            disableColumnMenu: true,
            hideSortIcons: true,
            minWidth: 80,
            renderCell: (params) => (_jsx(Typography, { sx: {
                    color: statusTextColor[3],
                    fontWeight: 500,
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                }, children: convertToNLEuroFormat(params.value || "0") })),
        },
        {
            field: "actions",
            headerName: "",
            sortable: false,
            align: "left",
            headerAlign: "left",
            disableColumnMenu: true,
            hideable: false,
            filterable: true,
            hideSortIcons: true,
            minWidth: 80,
            renderCell: (params) => (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: (event) => {
                            event.stopPropagation();
                            handleOpenMenu(event, resolveRowId(params.row));
                        }, children: _jsx(GridMoreVertIcon, {}) }), _jsxs(Menu, { anchorEl: menuAnchor, open: Boolean(menuAnchor) && menuRowId === resolveRowId(params.row), onClose: handleCloseMenu, children: [Boolean(params.row.isContracted) === false &&
                                checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(MenuItem, { onClick: () => {
                                    handleOpenAssignObjectModal(params.row.id);
                                    handleCloseMenu();
                                }, children: translate("Assign to lead") })), _jsx(MenuItem, { onClick: () => {
                                    handleOpenEditModal(params.row);
                                    handleCloseMenu();
                                }, children: translate("Edit") }), Boolean(params.row.isContracted) === false &&
                                checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(MenuItem, { sx: { color: resultTextColor[2] }, onClick: () => {
                                    deleteObject(params.row.leadObjectId);
                                    handleCloseMenu();
                                }, children: translate("Delete") }))] })] })),
        },
    ];
    // Add searchFields state
    const [searchFields, setSearchFields] = useState({
        searchObjectId: "",
        searchName: "",
        searchRole: "__all__",
        searchInternalComments: "",
        searchInternalCommentsMode: "all", // 'all' | 'has' | 'none'
    });
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    // Memoized filtered rows for performance
    const filteredRows = useMemo(() => {
        const objectIdSearch = searchFields.searchObjectId.trim().toLowerCase();
        const nameSearch = searchFields.searchName.trim().toLowerCase();
        const roleSearch = searchFields.searchRole;
        const commentsMode = searchFields.searchInternalCommentsMode || "all";
        const commentsSearch = searchFields.searchInternalComments
            .trim()
            .toLowerCase();
        return (leadObjects !== null && leadObjects !== void 0 ? leadObjects : []).filter((row) => {
            var _a, _b, _c;
            // ObjectId
            const objectIdMatch = !objectIdSearch ||
                ((_a = row.objectID) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(objectIdSearch));
            // Name
            const nameMatch = !nameSearch || ((_b = row.name) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(nameSearch));
            // Role logic
            let roleMatch = true;
            if (roleSearch && roleSearch !== "__all__") {
                roleMatch = row.companyRoleId === roleSearch;
            }
            // Internal Comments presence + substring logic (explicit branching)
            const internalText = ((_c = row.internalComments) !== null && _c !== void 0 ? _c : "").trim().toLowerCase();
            const hasInternalComments = internalText.length > 0;
            let commentMatch = true;
            if (commentsMode === "has") {
                commentMatch =
                    hasInternalComments &&
                        (!commentsSearch || internalText.includes(commentsSearch));
            }
            else if (commentsMode === "none") {
                commentMatch = !hasInternalComments;
            }
            else {
                // all
                commentMatch = !commentsSearch || internalText.includes(commentsSearch);
            }
            return objectIdMatch && nameMatch && roleMatch && commentMatch;
        });
    }, [leadObjects, searchFields]);
    // Reset only search fields on tab/data change
    useEffect(() => {
        if (tabIndex === objectTabIndex) {
            setSearchFields({
                searchObjectId: "",
                searchName: "",
                searchRole: "__all__",
                searchInternalComments: "",
                searchInternalCommentsMode: "all",
            });
            setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
        }
    }, [tabIndex, objectTabIndex, leadObjectsProp]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                    padding: { xs: "4px 8px", sm: "8px 16px", md: "16px 32px" }
                }, children: _jsxs(Grid, { container: true, sx: {
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1
                    }, children: [_jsx(Typography, { variant: "h2", children: translate("Object") }), _jsxs(Box, { sx: {
                                display: "flex",
                                flexDirection: "row",
                                gap: 1.5,
                                alignItems: "center"
                            }, children: [checkRead(RolesPermissions, Modules.ChangeObjectStatus) && (_jsx(Button, { variant: "outlined", sx: {
                                        borderRadius: "12px",
                                        border: "var(--none, 1px) solid var(--n-primary, #130922)",
                                        background: "var(--n-primary-light, #F9F6FF)",
                                        display: "flex",
                                        padding: "12px !important",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                        minWidth: "auto !important",
                                    }, onClick: handleOpenChangeStatusModal, children: translate("changeStatus") })), checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(Button, { type: "submit", variant: "outlined", sx: {
                                        borderRadius: "12px",
                                        border: "var(--none, 1px) solid var(--n-primary, #130922)",
                                        background: "var(--n-primary-light, #F9F6FF)",
                                        display: "flex",
                                        padding: "12px !important",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                        minWidth: "auto !important",
                                    }, onClick: handleOpenModal, children: _jsx(Plus, { size: 24 }) }))] }), isObjectLoading || loading ? (_jsx(Box, { sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "300px",
                                width: "100%"
                            }, children: _jsx(CircularProgress, {}) })) : leadObjectsProp && leadObjectsProp.length > 0 ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { container: true, size: 12, spacing: 2, sx: {
                                        display: "flex",
                                        alignItems: "center"
                                    }, children: [_jsx(Grid, { size: {
                                                xs: 6,
                                                md: 3
                                            }, children: _jsxs(FormControl, { fullWidth: true, variant: "outlined", children: [_jsx(InputLabel, { className: "border-radius", htmlFor: "search-leadObjectId", children: translate("ID") }), _jsx(OutlinedInput, { className: "border-radius", id: "search-leadObjectId", value: searchFields.searchObjectId, onChange: (e) => {
                                                            setSearchFields((prev) => (Object.assign(Object.assign({}, prev), { searchObjectId: e.target.value })));
                                                            setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
                                                        }, label: translate("ID"), sx: { borderRadius: "8px", padding: "0px" }, placeholder: translate("Search") + " " + translate("ID") })] }) }), _jsx(Grid, { size: {
                                                xs: 6,
                                                md: 3
                                            }, children: _jsxs(FormControl, { fullWidth: true, variant: "outlined", children: [_jsx(InputLabel, { className: "border-radius", htmlFor: "search-name", children: translate("Name") }), _jsx(OutlinedInput, { className: "border-radius", id: "search-name", value: searchFields.searchName, onChange: (e) => {
                                                            setSearchFields((prev) => (Object.assign(Object.assign({}, prev), { searchName: e.target.value })));
                                                            setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
                                                        }, label: translate("Name"), sx: { borderRadius: "8px" }, placeholder: translate("Search") + " " + translate("Name") })] }) }), _jsx(Grid, { size: {
                                                xs: 6,
                                                md: 6
                                            }, children: _jsx(Autocomplete, { disablePortal: true, fullWidth: true, id: "combo-box-demo", options: companyRoleFilterOptions, isOptionEqualToValue: (option, v) => option.id === v.id, getOptionLabel: (option) => option.name || "", value: companyRoleFilterOptions.find((role) => role.id === searchFields.searchRole) || null, onChange: (_, newValue) => {
                                                    setSearchFields((prev) => {
                                                        var _a;
                                                        return (Object.assign(Object.assign({}, prev), { 
                                                            // Map clear to '__all__' to explicitly apply the All option
                                                            searchRole: (_a = newValue === null || newValue === void 0 ? void 0 : newValue.id) !== null && _a !== void 0 ? _a : "__all__" }));
                                                    });
                                                    setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
                                                }, renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { fullWidth: true, label: translate("Role") }))) }) }), _jsx(Grid, { size: 6, children: _jsxs(FormControl, { fullWidth: true, variant: "outlined", children: [_jsx(InputLabel, { className: "border-radius", htmlFor: "search-internalComments-mode", children: translate("InternalComments") }), _jsxs(Select, { labelId: "search-internalComments-mode", id: "search-internalComments-mode", label: translate("InternalComments"), value: searchFields.searchInternalCommentsMode, onChange: (e) => {
                                                            const newValue = e.target.value;
                                                            setSearchFields((prev) => (Object.assign(Object.assign({}, prev), { searchInternalCommentsMode: newValue, 
                                                                // Clear substring when switching to 'none' to avoid conflicting filters
                                                                searchInternalComments: newValue === "none"
                                                                    ? ""
                                                                    : prev.searchInternalComments })));
                                                            setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
                                                        }, children: [_jsx(MenuItem, { value: "all", children: translate("All") }), _jsx(MenuItem, { value: "has", children: translate("InternalComments") }), _jsx(MenuItem, { value: "none", children: translate("NoInternalComments") })] })] }) }), _jsx(Grid, { size: 6, children: _jsxs(FormControl, { fullWidth: true, variant: "outlined", children: [_jsx(InputLabel, { className: "border-radius", htmlFor: "search-internalComments", children: translate("InternalComments") }), _jsx(OutlinedInput, { className: "border-radius", id: "search-internalComments", value: searchFields.searchInternalComments, disabled: searchFields.searchInternalCommentsMode === "none", onChange: (e) => {
                                                            setSearchFields((prev) => (Object.assign(Object.assign({}, prev), { searchInternalComments: e.target.value })));
                                                            setPaginationModel((prev) => (Object.assign(Object.assign({}, prev), { page: 0 })));
                                                        }, label: translate("InternalComments"), sx: { borderRadius: "8px" }, placeholder: translate("Search") +
                                                            " " +
                                                            translate("InternalComments") })] }) })] }), _jsx(Paper, { sx: {
                                        width: "100%",
                                        overflow: "hidden",
                                        boxShadow: "none",
                                    }, children: _jsx(DataGrid, { loading: loading, rows: filteredRows, getRowId: resolveRowId, onRowClick: handleEvent, columns: columnsForDataGrid, pagination: true, paginationModel: paginationModel, onPaginationModelChange: setPaginationModel, pageSizeOptions: [5, 10, 20, 50], disableRowSelectionOnClick: true, rowHeight: 80, localeText: {
                                            noRowsLabel: translate("Geen rijen"),
                                            noResultsOverlayLabel: translate("Geen resultaten"),
                                        }, sx: {
                                            border: "none",
                                            fontSize: "14px",
                                            height: {
                                                xs: "400px",
                                                md: "calc(100% - 140px)",
                                            },
                                            maxHeight: {
                                                md: "calc(100vh - 100px)",
                                            },
                                            "& .has-contract-row": {
                                                backgroundColor: "#ffff",
                                            },
                                            "& .MuiDataGrid-cell": {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                display: "block",
                                                alignItems: "center",
                                            },
                                            "& .MuiDataGrid-columnHeaderTitle ": {
                                                fontSize: "14px",
                                                fontWeight: 500,
                                            },
                                        }, sortingOrder: ["asc", "desc"] }, "leads-grid") })] })) : (_jsx(Box, { sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "300px",
                                width: "100%"
                            }, children: _jsx(Typography, { children: translate("addNewObject") }) }))] }) }), _jsx(ObjectModal, { open: modalOpen, onClose: handleCloseModal, refresh: () => setRefresh((prev) => !prev), initialFormData: initialFormData, data: leadObject, assetsData: assetOptions, setData: setLeadobject, setActionTabRefresh: setActionTabRefresh, companyRoles: companyRoles, statusTree: statusTree }), _jsx(ChangeStatusModal, { open: changeStatusOpen, onClose: handleCloseChangeStatusModal, refresh: () => {
                    setRefresh((prev) => !prev);
                    // immediate UI refresh while backend updates
                    setActionTabRefresh((prev) => !prev);
                }, statusTree: statusTree, objects: leadObjects, leadId: leadId }), _jsx(AssignObjectToLeadModal, { open: modalAssignObjectOpen, onClose: handleCloseAssignObjectModal, objectId: selectedObjectId, setObjectId: setSelectedObjectId, setRefreshModalData: setRefreshModalData, setActionTabRefresh: setActionTabRefresh, setRefresh: setRefresh, companyRoles: companyRoles, leads: leadOptions })] }));
};
export default ObjectTab;
